import { Component, OnInit } from '@angular/core';
import { DocumentModel } from 'src/app/shared/models/document.model';
import { CopyService } from 'src/app/shared/services/copies/copy.service';
import { HeaderService } from 'src/app/shared/services/header/header.service';
import { NavigationService } from 'src/app/shared/services/navigation/navigation-onboarding.service';

@Component({
  selector: 'app-bonding-successfully-created',
  templateUrl: './bonding-successfully-created.component.html',
  styleUrls: ['./bonding-successfully-created.component.scss'],
})
export class BondingSuccessfullyCreatedComponent implements OnInit {
  documentInfo: DocumentModel = {
    document_number: '',
    document_type: '',
    primary_lastname: '',
    second_lastname: '',
    firstname: '',
    middlename: '',
    sex: '',
    birthdate: '',
    finger_printed: 0,
  };
  cards: any[] = [
    {
      title_card: 'Clásica visa',
      text_card: 'text-card',
      money_card: '1.500.000',
    },
    {
      title_card: 'Clásica visa',
      text_card: 'text-card',
      money_card: '1.500.000',
    },
  ];

  screenCopies: any = {};
  maskedPhone: any = '1111111111';

  constructor(
    public copyService: CopyService,
    private headerService: HeaderService,
    private navigationService: NavigationService,

  ) { }

  ngOnInit() {
    // TODO: data quemada
    this.documentInfo.firstname = 'Ana';
    this.documentInfo.finger_printed = 0;
    // fin data quemada
    this.cards = this.copyService.copies.detail_bonding_mock;
    this.headerService.show(false, false, true);
  }
}
